import { useState } from 'react'
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'
import InputComponent from '../Input'
import { PassButton } from './style'

const PasswordInput = ({ placeholder, onChange, login }) => {
  const [passwordShown, setPasswordShown] = useState(false)

  const togglePassword = () => {
    setPasswordShown(!passwordShown)
  }
  return (
    <>
      <InputComponent
        name="password"
        login={login}
        type={passwordShown ? 'text' : 'password'}
        onChange={onChange}
        placeholder={placeholder}
      ></InputComponent>
      <PassButton type="button" onClick={togglePassword}>
        {passwordShown ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
      </PassButton>
    </>
  )
}
export default PasswordInput
